import {
  EDITOR_MODE_MARKDOWN,
  EDITOR_MODES
} from "../../../../../constants/EditorMode";

const plugin = function(editor) {
  const modeChangeHandler = editor.settings.editorMode.changeHandler;

  editor.addButton('tistory-mode', {
    type: 'ListBox',
    text: '기본모드',
    classes: 'tistory-mode',
    fixedWidth: true,
    menu: {
      items: EDITOR_MODES.map(mode => Object.assign({classes:'tistory-mode-item'}, mode))
    },
    onSelect(e) {
      modeChangeHandler(e.target.settings.value);
    },
    onShowMenu() {
      editor.fire('blur'); // editor에 onChange 이벤트를 발생하기 위함
      this.menu.moveRel(this.getEl(), ['bc-tc', 'tc-bc']);
    }
  })
};

export default plugin
